// Merged from all type="module" scripts, good try Veki

import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";

// SWIPER
import Swiper, { EffectCoverflow, Navigation } from "swiper";

Swiper.use([EffectCoverflow, Navigation]);

// TAILWIND CONFIG
import tw from "tailwind-config";
const tailwind = tw.config();

//Header
const header = document.getElementById("header");
const menuTrigger = document.getElementById("header-menu-trigger");

Object.values(header.querySelectorAll("a")).forEach((el) => {
  el.addEventListener("click", () => {
    if (!el.hasAttribute("data-sub-trigger")) {
      menuTrigger.checked = false;
    }
  });
});

const headerBg = () => {
  const header = document.getElementById("header");
  window.pageYOffset || !document.getElementById("hero")
    ? header.classList.add("not-on-top")
    : header.classList.remove("not-on-top");
};

headerBg();
window.addEventListener("scroll", () => {
  headerBg();
});

try {
  Object.values(document.querySelectorAll("[data-sub-trigger]")).forEach(
    (item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();

        const li = e.target.closest("li");

        Array.from(li.parentElement.children).forEach((el) => {
          if (el != li) el.classList.remove("active")
        });

        li.classList.toggle("active");
      });
    }
  );
} catch {}

// About
try {
  new Swiper("[data-swiper-about]", {
    slidesPerView: 1,
    spaceBetween: 50,
    speed: 1000,
    navigation: {
      nextEl: "[data-swiper-about-next]",
      prevEl: "[data-swiper-about-prev]",
    },
  });
  window.dispatchEvent(new Event("resize"));
} catch {
  console.log("Swiper is not defined");
}

// Related posts
try {
  new Swiper("[data-swiper-related-posts]", {
    slidesPerView: 2.5,
    spaceBetween: 20,
    speed: 1000,
    navigation: {
      nextEl: "[data-swiper-related-posts-next]",
      prevEl: "[data-swiper-related-posts-prev]",
    },
    breakpoints: {
      0: {
        spaceBetween: 10,
        slidesPerView: 1.2,
      },
      [parseInt(tailwind.theme.screens.md)]: {
        spaceBetween: 10,
        slidesPerView: 1.2,
      },
      [parseInt(tailwind.theme.screens.lg)]: {
        spaceBetween: 30,
        slidesPerView: 2.5,
      },
      [2400]: {
        spaceBetween: 30,
        slidesPerView: 3.4,
      },
    },
  });

  window.dispatchEvent(new Event("resize"));
} catch {
  console.log("Swiper is not defined");
}

// Testimonials
try {
  new Swiper("[data-swiper-testimonials]", {
    slidesPerView: 2.5,
    spaceBetween: 50,
    breakpoints: {
      0: {
        spaceBetween: 10,
        slidesPerView: 1.2,
      },
      [parseInt(tailwind.theme.screens.md)]: {
        spaceBetween: 10,
        slidesPerView: 1.2,
      },
      [parseInt(tailwind.theme.screens.lg)]: {
        spaceBetween: 50,
        slidesPerView: 2.5,
      },
    },
    speed: 1000,
    navigation: {
      nextEl: "[data-swiper-testimonials-next]",
      prevEl: "[data-swiper-testimonials-prev]",
    },
  });

  window.dispatchEvent(new Event("resize"));
} catch (e) {
  console.log(e);
}

//  Gallery
const galleries = document.querySelectorAll("[data-gallery]");

if (galleries.length) {
  Object.values(galleries).forEach((gallery) => {
    lightGallery(gallery, {
      plugins: [lgThumbnail],
      licenseKey: "your_license_key",
      animateThumb: false,
      zoomFromOrigin: false,
      allowMediaOverlap: true,
      toggleThumb: true,
      speed: 500,
    });
  });
}

// Dynamic sidebar
const sidebar = Object.values(document.querySelectorAll("[data-sidebar]"));
const prose = document.querySelector("[data-prose]");
const headingItems = prose ? prose.querySelectorAll("h2, h3") : [];

if (sidebar.length) {
  Object.values(sidebar).forEach((sidebar) => {
    headingItems.forEach((el, index) => {
      if (el.tagName === "H2") {
        const id = `h2-${index}`;
        el.setAttribute("id", id);
        sidebar.innerHTML += `<li><a class="block text-base" href="#${id}">${el.innerText}</a></li>`;
      } else {
        const id = `h3-${index}`;
        el.setAttribute("id", id);
        sidebar.innerHTML += `<li><a class="block ml-2 border-l border-primary/50 pl-2 text-md" href="#${id}">${el.innerText}</a></li>`;
      }
    });
  });
}

// Scroll to link
const headerHeight = document.getElementById("header").offsetHeight;

document.documentElement.style.setProperty(
  "--header-height",
  headerHeight + "px"
);

document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();

    // Close all dialogs
    document.querySelectorAll("dialog").forEach((modal) => {
      modal.close();
    });

    const el = document.getElementById(
      link.getAttribute("href").replace("#", "")
    );

    window.scroll({
      top: el
        ? el.getBoundingClientRect().top + window.scrollY - headerHeight
        : 0,
      behavior: "smooth",
    });
  });
});
